var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"d2-highlight hljs",domProps:{"innerHTML":_vm._s(_vm.highlightHTML)}})
}
var staticRenderFns = []

export { render, staticRenderFns }